import React, { useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { TOKEN_RAIN, BUY, MARKET_BUY, getMarketTokenByLabel } from '../../utils/constants'
import { handleToFixedOnDecimals, formatNumberWithCommas, formatSmartDecimal, formatNumbers, hexToRgb, isStableTokenSymbol } from '../../utils/helpers'
import { notifyError } from '../Toast'
import { DEFAULT_ERROR_HEADING } from '../../utils/ConstantMessages'
import { userSmartAccount } from '../RecoilAtom'
import { useRecoilValue } from 'recoil'
import { useSwipeClose } from '../../hooks/useSwipeClose'
import { useScrollLock } from './useScrollLock'

const OptionDetailMobileModal = ({
    show,
    onHide,
    selectedOptionDetail,
    tokenToDisplay,
    setMblTradeModalOpen,
    setBuyOrSellTabActive,
    setlimittab,
    tokenSymbol,
    tokenPriceToUsdt,
    isPoolFinalized,
    setSkipPrediction,
    onSelectBuyOption,
    poolstart,
    openWalletConnect,
    isClaimOpen
}) => {
    const {
        optionName,
        background,
        chanceFixed,
        updatedTotalInvestment,
        lineFixed,
        priceoptionFixed,
        mySharesFixed,
        sharePercentage,
        dynamicPayout,
        potentialPnl,
    } = selectedOptionDetail || {};
    const tokenIcon = tokenToDisplay === TOKEN_RAIN
        ? <img src="/assets/rain-icon.svg" alt="token" className="img-fluid" />
        : <img src={getMarketTokenByLabel(tokenToDisplay)?.icon} alt="token" className="img-fluid" />;
    useScrollLock(show);
    const smartAccount = useRecoilValue(userSmartAccount);
    const isRainToken = !isStableTokenSymbol(tokenSymbol);
    const dpValue = smartAccount ? (handleToFixedOnDecimals(dynamicPayout) || "0") : "0.00";
    const pnlRawValue = smartAccount ? (Number(potentialPnl) || 0) : 0;

    const handleBuyClick = () => {
        if (!smartAccount) {
            onHide();
            openWalletConnect();
            return;
        }
        if (new Date(poolstart) > new Date()) {
            onHide();
            notifyError(DEFAULT_ERROR_HEADING, "Market has not started yet.");
            return;
        }
        onSelectBuyOption(selectedOptionDetail?.option);
        setSkipPrediction(true);
        setBuyOrSellTabActive(BUY);
        setlimittab(MARKET_BUY);
        setMblTradeModalOpen(true);
        onHide();
    };


    const { r, g, b } = hexToRgb(background);

    const gradientBg = `linear-gradient(
  135deg,
  rgba(${r}, ${g}, ${b}, 0.15),
  rgba(${r}, ${g}, ${b}, 0.05)
)`;

    const borderStyle = `1px solid rgba(${r}, ${g}, ${b}, 0.3)`;

    const swipeRef = useSwipeClose(show, onHide);

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            className="pollmodal sharesocial-modal new-modal-style place-specific-trade-modal overflowhiddenformobile"
            animation={false}
        >
            <Modal.Header ref={swipeRef} onClick={onHide}>
                <div className="close-div" ></div>
            </Modal.Header>
            <Modal.Body>
                <div className="parent">
                    <div className="upper-field">
                        <div className="left-side">
                            <span className="dot-color" style={{ backgroundColor: background }}></span>
                            <h6>{optionName} <span style={{
                                background: gradientBg,
                                border: borderStyle,
                                color: background
                            }}>{chanceFixed}%</span></h6>
                        </div>
                        <div className="right-side">
                            <div className="left-sub">
                                <h6>
                                    {formatNumberWithCommas(updatedTotalInvestment)} {tokenIcon}
                                </h6>
                                <p>VOLUME</p>
                            </div>
                            <div className="right-sub">
                                <h6>{lineFixed}</h6>
                                <p>LINE</p>
                            </div>
                        </div>
                    </div>
                    <div className="price-per-share" style={{
                        background: gradientBg,
                        border: borderStyle
                    }}>
                        <div className="left-share">
                            <p>PRICE PER SHARE</p>
                            <h6>{handleToFixedOnDecimals(priceoptionFixed)} {tokenIcon}</h6>
                            {isRainToken && (
                                <p className="usdt-conversion">~ ${formatSmartDecimal(Number(priceoptionFixed * tokenPriceToUsdt || 0))} USD</p>
                            )}
                        </div>
                        <div className="icon-dollar" style={{
                            background: gradientBg,
                            border: borderStyle
                        }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="17" viewBox="0 0 10 17" fill="none">
                                <path d="M9.89695 10.842C9.89695 11.9187 9.51894 12.7778 8.76292 13.4193C8.00691 14.0608 6.95306 14.4159 5.6014 14.4846V16.22H4.38146V14.4674C2.99543 14.3643 1.91868 13.9519 1.15121 13.2303C0.395191 12.4972 0.0114548 11.4834 0 10.189H1.8385C1.87286 11.8042 2.72052 12.7034 4.38146 12.8867V8.69419L4.17528 8.64265C2.91525 8.39064 1.9645 7.97827 1.32303 7.40553C0.681561 6.83279 0.360826 6.04241 0.360826 5.03439C0.360826 4.06073 0.715925 3.27607 1.42612 2.68042C2.13632 2.08477 3.12143 1.76404 4.38146 1.71822V0H5.6014V1.75259C6.89579 1.89004 7.86945 2.29669 8.52237 2.97252C9.18675 3.6369 9.5304 4.50747 9.55331 5.58422H7.73199C7.68617 4.91984 7.49717 4.40437 7.16498 4.03782C6.83279 3.67126 6.3116 3.43644 5.6014 3.33335V7.21653L5.96222 7.28525C7.35971 7.58308 8.36201 8.01263 8.96911 8.57392C9.58767 9.13521 9.89695 9.89122 9.89695 10.842ZM4.38146 3.29898C3.68272 3.33335 3.15007 3.49944 2.78352 3.79727C2.41696 4.09509 2.23369 4.49601 2.23369 5.00002C2.23369 5.49258 2.38833 5.88777 2.69761 6.18559C2.99543 6.48342 3.55672 6.73542 4.38146 6.94161V3.29898ZM5.6014 8.95193V12.921C7.19362 12.795 7.98972 12.1192 7.98972 10.8935C7.98972 10.3895 7.81218 9.99432 7.45708 9.70794C7.10198 9.42158 6.48342 9.16957 5.6014 8.95193Z" fill={background} />
                            </svg>
                        </div>
                    </div>
                    <div className="option-field">
                        <div className="left-field">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M12.6667 4.66667V2.66667C12.6667 2.48986 12.5964 2.32029 12.4714 2.19526C12.3464 2.07024 12.1768 2 12 2H3.33333C2.97971 2 2.64057 2.14048 2.39052 2.39052C2.14048 2.64057 2 2.97971 2 3.33333C2 3.68696 2.14048 4.02609 2.39052 4.27614C2.64057 4.52619 2.97971 4.66667 3.33333 4.66667H13.3333C13.5101 4.66667 13.6797 4.7369 13.8047 4.86193C13.9298 4.98695 14 5.15652 14 5.33333V8M14 8H12C11.6464 8 11.3072 8.14048 11.0572 8.39052C10.8071 8.64057 10.6667 8.97971 10.6667 9.33333C10.6667 9.68696 10.8071 10.0261 11.0572 10.2761C11.3072 10.5262 11.6464 10.6667 12 10.6667H14C14.1768 10.6667 14.3464 10.5964 14.4714 10.4714C14.5964 10.3464 14.6667 10.1768 14.6667 10V8.66667C14.6667 8.48986 14.5964 8.32029 14.4714 8.19526C14.3464 8.07024 14.1768 8 14 8Z" stroke={background} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M2 3.33325V12.6666C2 13.0202 2.14048 13.3593 2.39052 13.6094C2.64057 13.8594 2.97971 13.9999 3.33333 13.9999H13.3333C13.5101 13.9999 13.6797 13.9297 13.8047 13.8047C13.9298 13.6796 14 13.5101 14 13.3333V10.6666" stroke={background} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <p>My Shares</p>
                        </div>
                        <div className="input-parent">
                            <input
                                type="number"
                                placeholder="0"
                                value={smartAccount ? (handleToFixedOnDecimals(mySharesFixed) || "") : "0.00"}
                                readOnly
                            />
                        </div>
                    </div>
                    <div className="decided-outcome-parent" style={!smartAccount ? { gridTemplateColumns: "1fr 1fr" } : {}}>
                        <div className="inside-box">
                            <p>Option Ownership</p>
                            <h6>{smartAccount ? sharePercentage : "0.00"}%</h6>
                        </div>
                        <div className="inside-box">
                            <p>{isPoolFinalized ? "Payout" : "Dynamic Payout"}</p>
                            <h6>{formatNumbers(+dpValue)} {tokenIcon}</h6>
                            {isRainToken && (
                                <p className="usdt-conversion">~ ${formatSmartDecimal(Number((smartAccount ? dynamicPayout : 0) * tokenPriceToUsdt || 0))} USD</p>
                            )}
                        </div>
                        {smartAccount && (
                            <div className="inside-box">
                                <p>{isPoolFinalized ? "PnL" : "Potential PnL"}</p>
                                <h6>{formatNumbers(+pnlRawValue)} {tokenIcon}</h6>
                                {isRainToken && (
                                    <p className="usdt-conversion">~ ${formatSmartDecimal(pnlRawValue * (Number(tokenPriceToUsdt) || 0))} USD</p>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="btn-buy">
                        <button onClick={handleBuyClick} disabled={isClaimOpen}>Buy</button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default OptionDetailMobileModal
